import moment from "moment";
import PropTypes from "prop-types";
import Loading from "../Base/Loading";
import styled from "styled-components";
import { Action, Fab } from "react-tiny-fab";
import MdAdd from "react-ionicons/lib/MdAdd";
import Host from "../../pages/NewLeave/Host";
import { Avatar, Divider, Input } from "reakit";
import Types from "../../pages/NewLeave/Types";
import React, { Component } from "react";
import { AutoFocusInside } from "react-focus-lock";
import MdCreate from "react-ionicons/lib/MdCreate";
import MdTrash from "react-ionicons/lib/MdTrash";
import { Box, Button, Card, Flex, Text } from "rebass";
import { Switch } from "@smooth-ui/core-sc";
import Transport from "../../pages/NewLeave/Transport";
import PositionBox from "../../components/Base/PositionBox";
import ConfirmDelete from "../../components/Modals/ConfirmDelete";

export const Datetime = styled(Input)`
  background: none;
`;

const textProps = {
  fontSize: "16px",
  fontWeight: 600,
  ml: "7px",
};

const dateProps = {
  fontSize: "16px",
  fontWeight: 600,
};

class LeaveDetailsCard extends Component {
  state = {
    editDetails: null,
    edit: false,
    loading: false,
    confirmDelete: false,
    is_urgent: false,
  };

  handleSelect = (type, value) => {
    const { editDetails } = this.state;
    this.setState({ editDetails: { ...editDetails, [type]: value } });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.details && prevProps.details !== this.props.details) {
      this.setState({ loading: false });
    }
  }

  handleInput = (e) => {
    const { editDetails } = this.state;
    if (e.target.type === "datetime-local") {
      let timeStamp = moment(e.target.value).unix();
      this.setState({
        editDetails: { ...editDetails, [e.target.name]: timeStamp },
      });
    } else {
      this.setState({
        editDetails: { ...editDetails, [e.target.name]: e.target.value },
      });
    }
  };

  handleDelete = async () => {
    const { profile, firebase, details, history, isAdmin } = this.props;
    if (isAdmin || profile.id === details.student_uid) {
      firebase
        .leave(details.id)
        .delete()
        .then(() => {
          history.replace("/app/leaves");
          history.push("/app/leaves");
        })
        .catch((error) => console.log("Error removing document: ", error));
    }
  };

  handleUpdate = async () => {
    let editDetails = this.state.editDetails;
    const { is_urgent } = this.state;
    const { details, closePopup } = this.props;
    try {
      let leaveRef = this.props.firebase.leave(details.id);
      if ((editDetails !== null && editDetails !== details) || is_urgent) {
        delete editDetails.id;
        if (editDetails.host && editDetails.host[0] === -1)
          editDetails.host = [];
        if (is_urgent) {
          if (details.parent_host) {
            editDetails = { ...editDetails, status: 7 };
          } else {
            editDetails = { ...editDetails, status: 10 };
          }
        }
        await leaveRef.update({ ...editDetails });
        if (is_urgent) closePopup();
      }
      this.setState({ edit: false });
    } catch (error) {
      console.log(error);
    }
    this.setState({ loading: false });
  };

  handleDelete = async () => {
    const { student, firebase, details } = this.props;
    if (student.id === details.student_uid) {
      firebase.leave(details.id).delete();
    }
    this.setState({ confirmDelete: false });
  };

  onSwitchUrgent = () => {
    const { is_urgent } = this.state;
    this.setState({ is_urgent: !is_urgent });
  };

  render() {
    const { edit, editDetails, loading, confirmDelete, is_urgent } = this.state;
    const {
      details,
      school,
      student,
      hosts,
      handleApprove,
      handleDecline,
      handleSignout,
      handleSignin,
      handleResend,
      handleUndoSignout,
      isAdmin,
      leave_type,
    } = this.props;
    let leaveDate,
      returnDate,
      type = null;
    if (details && details.start_date) {
      leaveDate = moment
        .unix(details.start_date)
        .format("MMM DD, YYYY     hh:mm A");
      if (details.end_date) {
        returnDate = moment
          .unix(details.end_date)
          .format("MMM DD, YYYY     hh:mm A");
      }
      if (details.leave_type) {
        type = school.leaveTypes[details.leave_type];
      }
    }

    return (
      <Box py={loading ? "40px" : "auto"}>
        {loading ? (
          <Loading />
        ) : (
          <Card boxShadow={"main"} p={3}>
            <Flex flexWrap={"wrap"} mt={0} p={0}>
              <Box width={1}>
                {student !== null && (
                  <Flex width={1} p={0}>
                    <Box width={1 / 2}>
                      <Text marginTop="15px" fontWeight={900} fontSize={"21px"}>
                        {student.first_name} {student.last_name}
                      </Text>
                    </Box>
                    <Box ml={"auto"} />
                    <Box>
                      <Avatar
                        src={student.profile_pic}
                        palette={"greys"}
                        opaque
                        tone={0}
                        fontSize={50}
                      />
                    </Box>
                  </Flex>
                )}
              </Box>
              {edit && leave_type === "Pending" && (
                <Flex justifyContent={"center"} alignItems={"center"}>
                  <Text px={"5px"}>Urgent Request</Text>
                  <Switch
                    name={"urgent_leave"}
                    checked={is_urgent}
                    onChange={this.onSwitchUrgent}
                  />
                </Flex>
              )}
              {edit ? (
                <Types
                  types={school.typeList}
                  handleSelect={this.handleSelect}
                  height={"100%"}
                  width={"50%"}
                  defaultValue={editDetails.leave_type}
                  value={editDetails.leave_type}
                />
              ) : (
                <Flex width={1} pb={3} pt={"10px"}>
                  <Box width={1 / 2}>
                    <Text mt="7px" {...textProps}>
                      Leave Type
                    </Text>
                  </Box>
                  <Box ml={"auto"} />
                  <Box>
                    <Text color="#969a9b" mt="7px" {...textProps}>
                      {type && type.name}
                    </Text>
                  </Box>
                </Flex>
              )}
              <Box width={1} py={1}>
                <Divider padding={0} margin={0} />
              </Box>

              {/* ----- LEAVE BY ----------- */}
              {edit ? (
                <Transport
                  types={school.transportTypes}
                  title={"Leave By"}
                  handleSelect={this.handleSelect}
                  height={"100%"}
                  width={"50%"}
                  name={"leave_transportation"}
                  defaultValue={editDetails.leave_transportation}
                  value={editDetails.leave_transportation}
                />
              ) : (
                <Flex width={1} py={3}>
                  <Box width={1 / 2}>
                    <Text marginTop="7px" {...textProps}>
                      Leave By
                    </Text>
                  </Box>
                  <Box ml={"auto"} />
                  <Box>
                    <Text color="#969a9b" {...textProps}>
                      {school.transportTypes
                        .filter(
                          (type) => type.id === details.leave_transportation
                        )
                        .map((type) => type.name)}
                    </Text>
                  </Box>
                </Flex>
              )}

              {/* ----- RETURN BY ----------- */}
              <Box width={1} py={1}>
                <Divider padding={0} margin={0} />
              </Box>
              {edit ? (
                <Transport
                  types={school.transportTypes}
                  title={"Return By"}
                  handleSelect={this.handleSelect}
                  height={"100%"}
                  width={"50%"}
                  name={"return_transportation"}
                  defaultValue={editDetails.return_transportation}
                  value={editDetails.return_transportation}
                />
              ) : (
                <Flex width={1} py={3}>
                  <Box width={1 / 2}>
                    <Text {...textProps}>Return By</Text>
                  </Box>
                  <Box ml={"auto"} />
                  <Box>
                    <Text color="#969a9b" {...textProps}>
                      {school.transportTypes
                        .filter(
                          (type) => type.id === details.return_transportation
                        )
                        .map((type) => type.name)}
                    </Text>
                  </Box>
                </Flex>
              )}
              <Box width={1} py={1}>
                <Divider padding={0} margin={0} />
              </Box>

              {/* ----- LEAVE AT ----------- */}
              <Flex width={1} py={edit ? 1 : 3}>
                <Box width={1 / 2} pl={edit ? 3 : 0}>
                  <Text
                    mt={edit ? "10px" : 0}
                    {...textProps}
                    fontWeight={"600"}
                  >
                    Leave At
                  </Text>
                </Box>
                <Box ml={"auto"} />
                <Box width={"55%"}>
                  {edit ? (
                    <Datetime
                      marginTop={0}
                      padding={0}
                      name={"start_date"}
                      onChange={this.handleInput}
                      color="#969a9b"
                      fontSize={"16px"}
                      fontWeight={"normal"}
                      defaultValue={moment
                        .unix(details.start_date)
                        .format()
                        .slice(0, 16)}
                      type="datetime-local"
                    />
                  ) : (
                    <Text color="#969a9b" {...dateProps}>
                      {leaveDate}
                    </Text>
                  )}
                </Box>
              </Flex>
              <Box width={1} py={1}>
                <Divider padding={0} margin={0} />
              </Box>

              {/* ----- RETURN AT ----------- */}
              <Flex width={1} py={edit ? 1 : 3}>
                <Box width={1 / 2} pl={edit ? 3 : 0}>
                  <Text
                    mt={edit ? "10px" : 0}
                    {...textProps}
                    fontWeight={"600"}
                  >
                    Return At
                  </Text>
                </Box>
                <Box ml={"auto"} />
                <Box width={"55%"}>
                  {edit ? (
                    <Datetime
                      marginTop={0}
                      padding={0}
                      onChange={this.handleInput}
                      name={"end_date"}
                      color="#969a9b"
                      {...dateProps}
                      fontSize={"16px"}
                      fontWeight={"normal"}
                      defaultValue={moment
                        .unix(details.end_date)
                        .format()
                        .slice(0, 16)}
                      type="datetime-local"
                    />
                  ) : (
                    <Text color="#969a9b" {...textProps}>
                      {returnDate}
                    </Text>
                  )}
                </Box>
              </Flex>
              <Box width={1} py={1}>
                <Divider padding={0} margin={0} />
              </Box>

              {/* ------  HOST -------- */}
              {edit ? (
                <Host
                  handleUpdate={this.handleSelect}
                  student={student}
                  defaultValue={editDetails.host ? editDetails.host : null}
                  height={"100%"}
                  width={"50%"}
                />
              ) : (
                <Flex width={1} py={3}>
                  <Box width={1 / 2}>
                    <Text marginTop="7px" {...textProps}>
                      Host
                    </Text>
                  </Box>
                  <Box ml={"auto"} />
                  <Box>
                    {hosts && hosts.length > 0 ? (
                      hosts.map((host) => (
                        <React.Fragment>
                          {student.parents &&
                          student.parents.includes(host.id) ? (
                            <Text color={"meta"} {...textProps} key={host.id}>
                              {host.first_name} {host.last_name} (Parent)
                            </Text>
                          ) : (
                            <Text color={"meta"} {...textProps} key={host.id}>
                              {host.first_name} {host.last_name}
                            </Text>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <Text color={"meta"} {...textProps}>
                        No Host Necessary
                      </Text>
                    )}
                  </Box>
                </Flex>
              )}

              {/* ----- DESTINATION ------ */}
              <Box width={1} py={1}>
                <Divider padding={0} margin={0} />
              </Box>
              {edit ? (
                <Box width={1} pt={2} pl={"12px"}>
                  <Input
                    name={"destination"}
                    onChange={this.handleInput}
                    defaultValue={editDetails.destination}
                    placeholder="Destination"
                    color="#969a9b"
                    fontSize={"16px"}
                    fontWeight={600}
                  />
                </Box>
              ) : (
                <Flex width={1} py={3}>
                  <Box width={1 / 2}>
                    <Text marginTop="7px" {...textProps}>
                      Destination
                    </Text>
                  </Box>
                  <Box ml={"auto"} />
                  <Box>
                    <Text color="#969a9b" {...textProps}>
                      {details.destination}
                    </Text>
                  </Box>
                </Flex>
              )}

              {/* ----------   NOTES ----------- */}
              <Box width={1} py={1}>
                <Divider padding={0} margin={0} />
              </Box>
              <Flex
                width={1}
                py={3}
                mb={3}
                flexDirection={"column"}
                flexWrap={"wrap"}
              >
                {!edit && (
                  <Box width={1 / 2}>
                    <Text marginTop="7px" {...textProps}>
                      Notes
                    </Text>
                  </Box>
                )}
                {edit ? (
                  <Box width={1} pt={2} pl={"12px"}>
                    <Input
                      name={"notes"}
                      onChange={this.handleInput}
                      defaultValue={editDetails.notes}
                      type="textarea"
                      placeholder="Notes..."
                      color="#969a9b"
                      {...textProps}
                    />
                  </Box>
                ) : (
                  <Box pt={2}>
                    <Text color="#969a9b" {...textProps}>
                      {details.notes}
                    </Text>
                  </Box>
                )}
              </Flex>
            </Flex>

            {/* Edit Save and Cancel Buttons */}
            {edit && (
              <PositionBox position={["fixed", "inherit"]} bottom={0} width={1}>
                <Card
                  boxShadow={["main", "none"]}
                  py={3}
                  variant={"buttonBar"}
                  bg={"white"}
                >
                  <Flex justifyContent={"space-evenly"}>
                    <Button
                      bg="green"
                      variant={"save"}
                      onClick={() => {
                        this.setState({ loading: true });
                        this.handleUpdate();
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      bg={"red"}
                      onClick={() => this.setState({ edit: false })}
                      variant={"save"}
                    >
                      Cancel
                    </Button>
                  </Flex>
                </Card>
              </PositionBox>
            )}

            <PositionBox position={["fixed", "inherit"]} bottom={0} width={1}>
              <Card
                width={1}
                boxShadow={[
                  details &&
                    (details.status === 0 ||
                      details.status === 11 ||
                      details.status === 4) &&
                    "main",
                  "none",
                ]}
                py={3}
                variant={"buttonBar"}
                bg={"white"}
              >
                <Flex>
                  {/* Approve Decline Signout Button */}
                  <Box width={4 / 5}>
                    {isAdmin && !edit && details && (
                      <React.Fragment>
                        {details.parent_host ? (
                          <React.Fragment>
                            {(details.status === 0 || details.status === 5) && (
                              <Flex justifyContent={"flex-start"}>
                                <Box pl={2}>
                                  <Button
                                    bg="green"
                                    variant={"approve"}
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </Button>
                                </Box>
                                <Box pl={2}>
                                  <Button
                                    bg={"red"}
                                    onClick={handleDecline}
                                    variant={"approve"}
                                  >
                                    Decline
                                  </Button>
                                </Box>
                                <Box pl={2}>
                                  <Button
                                    bg="purple"
                                    variant={"approve"}
                                    onClick={handleResend}
                                  >
                                    Resend
                                  </Button>
                                </Box>
                              </Flex>
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {(details.status === 0 ||
                              details.status === 5 ||
                              details.status === 6 ||
                              details.status === 9) && (
                              <Flex justifyContent={"flex-start"}>
                                <Box pl={2}>
                                  <Button
                                    bg="green"
                                    variant={"approve"}
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </Button>
                                </Box>
                                <Box pl={2}>
                                  <Button
                                    bg={"red"}
                                    onClick={handleDecline}
                                    variant={"approve"}
                                  >
                                    Decline
                                  </Button>
                                </Box>
                                <Box pl={2}>
                                  <Button
                                    bg="purple"
                                    variant={"approve"}
                                    onClick={handleResend}
                                  >
                                    Resend
                                  </Button>
                                </Box>
                              </Flex>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}

                    {isAdmin &&
                      !edit &&
                      details &&
                      (details.status === 4 ||
                        (!details.parent_host && details.status === 7) ||
                        details.status === 8) && (
                        <Flex justifyContent={"center"}>
                          <Button
                            bg="#969a9b"
                            variant={"approve"}
                            width={"265px !important"}
                          >
                            Approved by Deans
                          </Button>
                          <Box pl={2}>
                            <Button
                              bg="purple"
                              variant={"approve"}
                              onClick={handleResend}
                            >
                              Resend
                            </Button>
                          </Box>
                        </Flex>
                      )}

                    {!edit && details && details.status === 11 && (
                      <Flex justifyContent={"center"}>
                        <Button
                          bg="green"
                          variant={"approve"}
                          width={"265px !important"}
                          onClick={handleSignin}
                        >
                          Sign In
                        </Button>
                        <Box pl={2}>
                          <Button
                            bg="purple"
                            variant={"approve"}
                            onClick={handleUndoSignout}
                          >
                            Undo
                          </Button>
                        </Box>
                      </Flex>
                    )}

                    {!edit &&
                      student &&
                      student.parents &&
                      details &&
                      details.status > 3 &&
                      details.status < 11 && (
                        <Flex justifyContent={"center"}>
                          {details.parent_host && details.status === 7 && (
                            <Button
                              bg={student.on_leave ? "meta" : "green"}
                              disabled={student.on_leave}
                              variant={"signout"}
                              onClick={handleSignout}
                            >
                              <Text>
                                {student.on_leave ? "On Leave" : "Sign Out"}
                              </Text>
                            </Button>
                          )}
                          {!details.parent_host && details.status === 10 && (
                            <Button
                              bg={student.on_leave ? "meta" : "green"}
                              disabled={student.on_leave}
                              variant={"signout"}
                              onClick={handleSignout}
                            >
                              <Text>
                                {student.on_leave ? "On Leave" : "Sign Out"}{" "}
                              </Text>
                            </Button>
                          )}
                        </Flex>
                      )}
                  </Box>

                  {/* Edit button*/}
                  {!edit && (
                        <Box width={1 / 5}>
                          {(details.status === 0 ||
                            (details.status >= 4 && details.status <= 10)) && (
                            <Fab
                              mainButtonStyles={{
                                marginBottom: "-8px",
                                backgroundColor: "#FFC61A",
                                height: "47px",
                                width: "47px",
                              }}
                              icon={
                                <AutoFocusInside>
                                  <MdAdd color={"white"} />{" "}
                                </AutoFocusInside>
                              }
                              event={"click"}
                              actionButtonStyles={{ color: "black" }}
                            >
                              <Action
                                text={"Delete"}
                                onClick={() =>
                                  this.setState({ confirmDelete: true })
                                }
                              >
                                <MdTrash color={"white"} />
                              </Action>
                              <Action
                                text={"Edit"}
                                onClick={() =>
                                  edit
                                    ? this.setState({ edit: false })
                                    : this.setState({
                                        edit: true,
                                        editDetails: details,
                                      })
                                }
                              >
                                <MdCreate color={"white"} />
                              </Action>
                            </Fab>
                          )}
                          {details.status === 11 && (
                            <Fab
                              mainButtonStyles={{
                                marginBottom: "-8px",
                                backgroundColor: "#FFC61A",
                                height: "47px",
                                width: "47px",
                              }}
                              icon={
                                <AutoFocusInside>
                                  <MdAdd color={"white"} />{" "}
                                </AutoFocusInside>
                              }
                              event={"click"}
                              actionButtonStyles={{ color: "black" }}
                            >
                              <Action
                                text={"Edit"}
                                onClick={() =>
                                  edit
                                    ? this.setState({ edit: false })
                                    : this.setState({
                                        edit: true,
                                        editDetails: details,
                                      })
                                }
                              >
                                <MdCreate color={"white"} />
                              </Action>
                            </Fab>
                          )}
                        </Box>
                      )}
                </Flex>
              </Card>
              <ConfirmDelete
                visible={confirmDelete}
                toggle={() => this.setState({ confirmDelete: false })}
                handleConfirm={this.handleDelete}
              />
            </PositionBox>
          </Card>
        )}
      </Box>
    );
  }
}

LeaveDetailsCard.propTypes = {
  details: PropTypes.object,
  student: PropTypes.object,
  school: PropTypes.object,
  handleApprove: PropTypes.func,
  handleDecline: PropTypes.func,
  handleSignin: PropTypes.func,
  handleSignout: PropTypes.func,
  handleResend: PropTypes.func,
  handleUndoSignout: PropTypes.func,
  hosts: PropTypes.arrayOf(PropTypes.object),
};

LeaveDetailsCard.defaultProps = {
  handleApprove: () => console.log("approving leave"),
  handleDecline: () => console.log("declining leave"),
  handleSignin: () => console.log("singing in leave"),
  handleSignout: () => console.log("singing in leave"),
  handleResend: () => console.log("resending leave"),
  handleUndoSignout: () => console.log("undoing signout"),
};

export default LeaveDetailsCard;
